import { gql } from '@apollo/client';

export const LIST_DAILYCHIRPS_QUERY = gql`
  query ListDailychirps($hotelId: ID!, $type: ENUM_DAILYCHIRP_TYPE, $isFavorite: Boolean) {
    dailychirps(
      where: { hotel: $hotelId, type: $type, isFavorite: $isFavorite }
      sort: "date:desc"
      limit: 100
    ) {
      id
      date
      type
      isFavorite
      title
    }
  }
`;
